import { configureStore } from "@reduxjs/toolkit";
import authReducer, { overrideSubdomainAction, tokenAction } from "./auth/reducers";
import { getStoredAuthToken } from "../utils/authToken";
import forgotPassword from "./forgotPassword/reducers";
import locationReducer from "./locations/reducers";
import abacReducer from "./abac/reducers";
import cartReducer from "./cart/reducers";
import { setAxios } from "helpers";

// Configures the legacy bare-axios default instance (baseURL, auth +
// _subdomain headers, 401 handling) — some copied pages still call the
// global `axios` directly instead of the instances in src/api/index.js.
setAxios();

const store = configureStore({
  reducer: {
    auth: authReducer,
    forgotPassword: forgotPassword,
    // NOTE: the store key is singular `location` (matching every selector
    // in the copied pages) while the reducer directory is `locations/`.
    location: locationReducer,
    abac: abacReducer,
    cart: cartReducer,
  },
});

// Rehydrate the session from localStorage on hard refresh. tokenAction /
// overrideSubdomainAction also write back to localStorage (side effect in
// the reducers — inherited from flex2-webapp, load-bearing).
const storedAuthToken = getStoredAuthToken();
if (storedAuthToken) store.dispatch(tokenAction(storedAuthToken));

if (localStorage._subdomain) store.dispatch(overrideSubdomainAction(localStorage._subdomain));

export default store;
